import React from 'react';
import { cn } from '@app/shared/utils/common';

interface RangeProgressProps extends React.InputHTMLAttributes<HTMLInputElement> {
  progressColor?: string; // колір заповнення
  trackColor?: string; // колір заднього фону
}

export const RangeProgress: React.FC<RangeProgressProps> = ({
  className,
  progressColor = '#ffffff',
  trackColor = 'rgba(255, 255, 255, 0.25)',
  value = 0,
  max = 100,
  ...rest
}) => {
  const percent = (Number(value) / Number(max)) * 100;

  return (
    <input
      type="range"
      value={value}
      max={max}
      {...rest}
      style={{
        background: `
          linear-gradient(${progressColor}, ${progressColor}) 0/ ${percent}% 100% no-repeat,
          ${trackColor}
        `,
      }}
      className={cn(
        `flex-1 h-2 appearance-none rounded-lg cursor-pointer

        [&::-webkit-slider-thumb]:appearance-none
        [&::-webkit-slider-thumb]:w-4
        [&::-webkit-slider-thumb]:h-4
        [&::-webkit-slider-thumb]:rounded-full
        [&::-webkit-slider-thumb]:bg-white
        [&::-webkit-slider-thumb]:shadow-lg
        [&::-webkit-slider-thumb]:cursor-pointer
        [&::-webkit-slider-thumb]:transition-all
        [&::-webkit-slider-thumb]:hover:scale-110
        
        [&::-moz-range-thumb]:w-4
        [&::-moz-range-thumb]:h-4
        [&::-moz-range-thumb]:rounded-full
        [&::-moz-range-thumb]:bg-white
        [&::-moz-range-thumb]:cursor-pointer

        [&::-moz-range-track]:bg-transparent
      `,
        className
      )}
    />
  );
};
